"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import useElementId from "../../hooks/useElementId.js";
import { Provider } from "./FormControl.context.js";
import { getCaptionId } from "./FormControl.utilities.js";
import FormControlLabel from "./FormControlLabel.js";
import FormControlHelper from "./FormControlHelper.js";
import FormControlError from "./FormControlError.js";
const FormControl = (props) => {
    const { children, id: passedId, required, hasError, group, disabled, size } = props;
    const id = useElementId(passedId);
    const WrapperTagName = group ? "fieldset" : "div";
    const [helperRendered, setHelperRendered] = React.useState(false);
    const [errorRendered, setErrorRendered] = React.useState(false);
    const describedby = [
        helperRendered && getCaptionId(id),
        errorRendered && getCaptionId(id, "error"),
    ]
        .filter(Boolean)
        .join(" ");
    const attributes = { id, "aria-describedby": describedby };
    const errorRef = () => {
        setErrorRendered(true);
    };
    const helperRef = () => {
        setHelperRendered(true);
    };
    return (_jsx(WrapperTagName, { children: _jsx(Provider, { value: { required, hasError, errorRef, helperRef, attributes, group, disabled, size }, children: children }) }));
};
FormControl.Label = FormControlLabel;
FormControl.Helper = FormControlHelper;
FormControl.Error = FormControlError;
FormControl.displayName = "FormControl";
export default FormControl;
